import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ModemLights from '../ContactUs/ModemLights/ModemLights';
import FormTextContainer from '../../redux/containers/FormTextContainer';
import FormTextareaContainer from '../../redux/containers/FormTextareaContainer';
import Select from '../ContactUs/Select/Select';
import Choice from '../ContactUs/Choice/Choice';
import SubmitContactUsButton from '../ContactUs/SubmitContactUsButton/SubmitContactUsButton';
import FormHiddenContainer from '../../redux/containers/FormHiddenContainer';
import SmartModemStatus from '../ContactUs/SmartModemStatus/SmartModemStatus';
import ModemSelect from '../ContactUs/ModemSelect/ModemSelect';
import MonthYear from '../checkout/DayMonthYear/MonthYear';

const CustomField = (props) => {
  const { fieldType, value, cssClass, linkTo, autotestClass, linkDescription, textAfterLink } = props;
  if (fieldType === 'modem-lights') {
    return (<ModemLights {...props} />);
  } else if (fieldType === 'smart-modem-status') {
    return (<SmartModemStatus {...props} />);
  } else if (fieldType === 'text') {
    return (<FormTextContainer {...props} />);
  } else if (fieldType === 'textarea') {
    return (<FormTextareaContainer {...props} />);
  } else if (fieldType === 'choice') {
    return (<Choice {...props} />);
  } else if (fieldType === 'select') {
    return (<Select {...props} />);
  } else if (fieldType === 'submit-button') {
    return (<SubmitContactUsButton {...props} />);
  } else if (fieldType === 'hidden') {
    return (<FormHiddenContainer {...props} />);
  } else if (fieldType === 'modem-select') {
    return (<ModemSelect {...props} />);
  } else if (fieldType === 'month-year') {
    return (<MonthYear {...props} />);
  }
  return (
    <div className={cssClass}>
      {value}
      {linkTo && linkDescription &&
      <Link to={linkTo} target="_blank" className={autotestClass}>{linkDescription}</Link>
      }
      {textAfterLink}
    </div>
  );
};

CustomField.propTypes = {
  fieldType: PropTypes.string,
  value: PropTypes.string,
  autotestClass: PropTypes.string,
  cssClass: PropTypes.string,
  linkTo: PropTypes.string,
  linkDescription: PropTypes.string,
  textAfterLink: PropTypes.string
};

export default CustomField;



/** WEBPACK FOOTER **
 ** ./src/components/form/CustomField.js
 **/